import { z } from 'zod';
import { encryptedKeyByRsaKeyValidator, principalIdValidator, publicKeyValidator, signedEntityByRsaKeyValidator, } from '#validation';
export const CommonMemberCreateSchema = z.object({
    principalId: principalIdValidator({
        requiredError: 'member.principalId.required',
        formatError: 'member.principalId.uuid',
        forbiddenError: 'member.principalId.forbidden',
    }),
    publicKey: publicKeyValidator,
    ePrivateKeyByInvitationKey: encryptedKeyByRsaKeyValidator,
    eInvitationPrivateKeyByMemberKey: encryptedKeyByRsaKeyValidator,
    sMemberByInvitationKey: signedEntityByRsaKeyValidator,
});
